export namespace AccountManagement {
  export enum BILL_STATUS {
    PENDING = "UNPAID",
    PAID = "PAID"
  }
  export enum PAYMENT_METHODS {
    CARD = "CARD",
    ACH = "ACH",
    OFFLINE = "OFFLINE",
    NONE = "NONE"
  }

  export interface Account {
    id: number;
    customer_since: string;
    auto_bill: boolean;
    next_bill_date: string;
    next_bill_amount: number;
    plans: CannasuitePlans.PlanDefinition[];
    locations: { in_use: number; available: number };
    seats: { in_use: number; available: number };
    invoices: BillingInvoice[];
    mainPlan: CannasuitePlans.PlanDefinition | undefined;
    outstanding_amount: number;
    outstanding_invoices: number;
  }
  export interface BillingInvoice {
    id: number;
    date: string;
    due_date: string;
    status: BILL_STATUS;
    method: PAYMENT_METHODS;
    taxes_and_fees: number;
    amount: number;
    paid: number;
    plans: CannasuitePlans.PlanDefinition[];
  }

  export interface CreditCard {
    id: number;
    nickname: string;
    card_number: string;
    card_type: string;
    cvv: string;
    holder_name: string;
    expiration_month: string;
    expiration_year: string;
    identification_nro: string;
    identification_type: string;
    address: string;
    city: string | null;
    country_id: string | null;
    state: string | null;
    postcode: string;
    default: number;
  }

  export interface Availability {
    [key: string]: {
      addon: number;
      max: number;
      available: number;
      plan: number;
      used: number;
      cost_per_unit: string;
    };
  }
}

export namespace CannasuitePlans {
  export enum REGISTERED_PLANS {
    CANNASUITE = "cannasuite"
  }

  export const PLANS_MAPPER: { [key: string]: string } = {
    cannasuite: REGISTERED_PLANS.CANNASUITE
  };

  export interface PlanDefinition {
    name: REGISTERED_PLANS;
    price: number;
    currency_id: string;
    products: PlanProduct[];
    mapPlan?: any;
  }

  export interface PlanProduct {
    active: 1 | 0;
    created_at: string;
    id: number;
    name: string;
    settings: string;
    type: "CANNASUITE_SEATS" | "CANNASUITE_LOCATIONS" | "CANNASUITE_APIS";
    updated_at: string;
  }
}
